<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'
import { Input } from '@ds/primitives/input'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <Input
    data-slot="input-group-control"
    :class="cn(
      'flex-1 min-w-0 rounded-none border-0 bg-transparent focus-visible:shadow-none',
      props.class,
    )"
  />
</template>
